module.exports = __webpack_public_path__ + "img/legende125.56aee454.jpg";